export const MEASUREMENT_DATES_ACCORDION_PANEL_TEST_IDS = {
  addSubfolderButton: (measurementDateKey: string) =>
    `firm-documents-measurement-date-add-subfolder-${measurementDateKey}`,
  content: (measurementDateKey: string) => `firm-documents-measurement-date-content-${measurementDateKey}`,
  emptyState: 'firm-documents-measurement-dates-empty-state',
  errorState: 'firm-documents-measurement-dates-error-state',
  item: (measurementDateKey: string) => `firm-documents-measurement-date-${measurementDateKey}`,
  list: 'firm-documents-measurement-dates-list',
  root: 'firm-documents-measurement-dates-panel',
  selectAll: (measurementDateKey: string) => `firm-documents-measurement-date-select-all-${measurementDateKey}`,
  uploadDocumentButton: (measurementDateKey: string) =>
    `firm-documents-measurement-date-upload-document-${measurementDateKey}`,
  showMore: 'firm-documents-measurement-dates-show-more',
  showNewer: 'firm-documents-measurement-dates-show-newer',
  skeleton: 'firm-documents-measurement-dates-skeleton',
} as const;
